export default "__VITE_ASSET__CNT8pM2H__"